import './App.css';
import React, { Component } from 'react';
import { useSpring, animated } from 'react-spring';
import arrow from "./assets/icon-arrow.svg";
const AnimatedValue = ({ value }) => {
  const animatedValue = useSpring({ number: value, from: { number: 0 } });

  return (
    <animated.span>
      {animatedValue.number.interpolate((val) => Math.floor(val))}
    </animated.span>
  );
};

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      texto: '', // Estado para almacenar el texto del input

      month: '--',
      year: '--',
      day: '--',
      errors: [],
      monthCal: '',
      yearCal: '',
      dayCal: '',
    };
    this.validateForm = this.validateForm.bind(this);
  }
  validateForm() {
    let day = parseInt(this.state.dayCal);
    let year = parseInt(this.state.yearCal);
    let month = parseInt(this.state.monthCal);
    const errors = [];

    // Validar si algún campo está vacío
    if (!day) {
      errors.push('dayRequired');
    }
    if (!month) {
      errors.push('monthRequired');
    }
    if (!year) {
      errors.push('yearRequired');
    }

    if (day < 1 || day > 31) {
      errors.push('dayInvalid');
    }

    // Validar número de mes
    if (month < 1 || month > 12) {
      errors.push('monthInvalid');
    }

    // Validar año en el futuro
    const currentYear = new Date().getFullYear();
    if (year > currentYear) {
      errors.push('yearInvalid');
    }

    const daysInMonth = new Date(year, month, 0).getDate();
    if (day > daysInMonth) {
      errors.push('dayInvalid');
    }

    let age = {
      days: '--',
      months: '--',
      years: '--',
    };
    if (errors.length === 0) {
      const currentDate = new Date();
      const currentDay = currentDate.getDate();
      const currentMonth = currentDate.getMonth() + 1;
      const currentYear = currentDate.getFullYear();

      const birthDate = new Date(`${year}-${month}-${day}`);
      const birthDay = birthDate.getDate();
      const birthMonth = birthDate.getMonth() + 1;
      const birthYear = birthDate.getFullYear();

      let ageYears = currentYear - birthYear;
      let ageMonths = currentMonth - birthMonth;
      let ageDays = currentDay - birthDay;

      // Ajustar la edad si los meses o días son negativos
      if (ageMonths < 0 || (ageMonths === 0 && ageDays < 0)) {
        ageYears--;
        ageMonths += 12;
        if (ageDays < 0) {
          const daysInPreviousMonth = new Date(
            currentYear,
            currentMonth - 1,
            0
          ).getDate();
          ageDays += daysInPreviousMonth;
        }
      }
      age = {
        days: ageDays,
        months: ageMonths,
        years: ageYears,
      };
    }

    this.setState({
      errors: errors,
      month: age.months,
      day: age.days,
      year: age.years,
    });
  }

  handleChange = (event, max, text) => {
    let nuevoTexto = event.target.value;

    // Eliminar caracteres no numéricos
    nuevoTexto = nuevoTexto.replace(/\D/g, '');

    nuevoTexto = nuevoTexto.substring(0, max);

    this.setState({ [text]: nuevoTexto });
  };

  render() {

    return (
      <div className="box">
        <div className="top">
          <div className="inline">
            <p>DAY</p>
            <input
              required
              className="main-input"
              type="text"
              placeholder="DD"
              value={this.state.dayCal}
              onChange={(event) => this.handleChange(event, 2, 'dayCal')}
            ></input>
            {this.state.errors.includes('dayRequired') ? (
              <p className="error-log">This field is required</p>
            ) : this.state.errors.includes('dayInvalid') ? (
              <p className="error-log">Must be a valid day</p>
            ) : null}
          </div>
          <div className="inline">
            <p>MONTH</p>
            <input
              required
              className="main-input"
              type="text"
              placeholder="MM"
              value={this.state.monthCal}
              onChange={(event) => this.handleChange(event, 2, 'monthCal')}
            ></input>
            {this.state.errors.includes('monthRequired') ? (
              <p className="error-log">This field is required</p>
            ) : this.state.errors.includes('monthInvalid') ? (
              <p className="error-log">Must be a valid month</p>
            ) : null}
          </div>
          <div className="inline">
            <p>YEAR</p>
            <input
              required
              className="main-input"
              type="text"
              placeholder="YYYY"
              value={this.state.yearCal}
              onChange={(event) => this.handleChange(event, 4, 'yearCal')}
            ></input>
            {this.state.errors.includes('yearRequired') ? (
              <p className="error-log">This field is required</p>
            ) : this.state.errors.includes('yearInvalid') ? (
              <p className="error-log">Must be in the past</p>
            ) : null}{' '}
          </div>
        </div>
        <div className="mid">
          <div className="line"></div>
          <div
            type="submit"
            onClick={() => this.validateForm()}
            className="circle"
          >
            <img alt="arrow icon" src={arrow}></img>
          </div>
        </div>
        <div className="bot">
          <p className="age">
            <span>
              {typeof this.state.year === 'number' ? (
                <AnimatedValue value={this.state.year} />
              ) : (
                this.state.year
              )}
            </span>{' '}
            years
          </p>
          <p className="age">
            <span>
              {typeof this.state.month === 'number' ? (
                <AnimatedValue value={this.state.month} />
              ) : (
                this.state.month
              )}
            </span>{' '}
            months
          </p>
          <p className="age">
            <span>
              {typeof this.state.day === 'number' ? (
                <AnimatedValue value={this.state.day} />
              ) : (
                this.state.day
              )}
            </span>{' '}
            days
          </p>
        </div>
      </div>
    );
  }
}

export default App;
